import axiosInstance from 'src/utils/axios';
import {
  GetProjectsListQuery,
  ProjectListResponse,
  ProjectQuery,
  ProjectResponse,
} from './types.api';

//
//

const BASE_URL = 'projects/v2';

//

export const getProjectByCodeAPI = async (
  params: ProjectQuery,
  options?: any
): Promise<ProjectResponse> => {
  const { projectCode, ...query } = params;

  const response = await axiosInstance.get<ProjectResponse>(`${BASE_URL}/${projectCode}`, {
    params: query,
  });

  if (!response.data) throw new Error('Unexpected API response');

  return response?.data;
};

export const getProjectsApi = async (query: GetProjectsListQuery): Promise<ProjectListResponse> => {
  const { merchantCode, countryCode, locale, filters, currency } = query;

  let queryArray = ['includePublic=true'];
  if (merchantCode) queryArray.push('merchantCode=' + merchantCode);
  if (locale) queryArray.push('locale=' + locale);
  if (countryCode) queryArray.push('countryCode=' + countryCode);
  if (currency) queryArray.push('currency=' + currency);
  if (filters?.regions) queryArray.push('regions=' + filters?.regions);
  if (filters?.methodCategory)
    queryArray.push('methodCategories=' + filters?.methodCategory);
  if (filters?.registry) queryArray.push('registryCodes=' + filters?.registry);
  if (filters?.eligibility) queryArray.push('eligibility=' + filters?.eligibility);
  if (filters?.vintage) queryArray.push('vintage=' + filters?.vintage);
  if (filters?.minPricePerTonne != null) queryArray.push('minPricePerTonne=' + filters?.minPricePerTonne);
  if (filters?.maxPricePerTonne != null) queryArray.push('maxPricePerTonne=' + filters?.maxPricePerTonne);
  if (filters?.sort) queryArray.push('sort=' + filters?.sort);
  if (filters?.projectIds) {
    filters.projectIds.forEach((id: string) => queryArray.push('projectIds=' + id));
  }
  if (filters?.statuses) {
    filters.statuses.forEach((s: string) => queryArray.push('status=' + s));
  }
  if (filters?.goalNums) {
    filters.goalNums.forEach((n: string) => queryArray.push('goalNums=' + n));
  }
  // searches all text fields; including highlights
  if (filters?.searchTerm) queryArray.push('searchTerm=' + filters?.searchTerm);
  let queryString = queryArray.length ? '?' + queryArray.join('&') : '';

  const response = await axiosInstance.get<ProjectListResponse>(`${BASE_URL}/${queryString}`);

  if (!response.data) throw new Error('Unexpected API response');

  return response?.data;
};
